/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

function RadialProgressBar({
    percentage,
    fillColor = "#0780c7",
    radius,
    centerColor = "#474747",
    fontColor = "#f2f2f2",
    ...otherAttributes
}) {
    return (
        <a-entity class="RadialProgressBar" {...otherAttributes}>
            <a-cylinder
                color={fillColor}
                height="0.1"
                radius={radius}
                theta-length={3.6 * percentage}
                theta-start="180"
                rotation="90 90 90"
                side="double"
            >
                <a-cylinder
                    color={centerColor}
                    height="0.1"
                    radius={radius * 0.7}
                    position="0 0.1 0"
                    side="double"
                    opacity="0.8"
                >
                    <Text
                        value={percentage + " %"}
                        align="center"
                        color={fontColor}
                        width={radius * 0.7}
                        size="h2"
                        position="0 0.1 0"
                        rotation="-90 0 0"
                    />
                </a-cylinder>
            </a-cylinder>
        </a-entity>
    );
}

RadialProgressBar.propTypes = {
    percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    radius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default RadialProgressBar;
